import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetApiCalculatedFiltersIdAppGroupIdEngagementsResult = objectOf({
  engagements: objectOf({
    campaigns: arrayOf(objectOf({ id: string, name: string, status: string })),
    canvases: arrayOf(objectOf({ id: string, name: string, status: string })),
    canvas_steps: arrayOf(
      objectOf({
        id: string,
        name: string,
        canvas_id: string,
        canvas_name: string,
        canvas_status: string,
      })
    ),
    segments: arrayOf(objectOf({ id: string, name: string, status: string })),
  }),
});
